import { configureStore } from "@reduxjs/toolkit";
import authReducer from './redux/slices/auth/authSlice'
import accessReducer from './redux/slices/accessToken/accessTokenSlice'
import checkoutReducer from './redux/slices/checkout/checkoutSlice'
import userReducer from './redux/slices/user/userSlice'
import subscriptionsReducer from './redux/slices/subscriptions/subscriptionsSlice'
import lyfshortServiceMiddleware from "./redux/middlewares/lyfshortService";
import triplinkServiceMiddleware from "./redux/middlewares/triplinkService";
import firebaseAuthMiddleware from "./redux/middlewares/firebaseAuthService";
import expertReducer from './redux/slices/expert/expertSlice'
import businessReducer from './redux/slices/business/businessSlice'
import businessMemberReducer from './redux/slices/businessMember/businessMemberSlice'
import leadsReducer from './redux/slices/leads/leadsSlice'
import meetingsReducer from './redux/slices/meetings/meetingsSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    accessToken: accessReducer,
    checkout: checkoutReducer,
    user: userReducer,
    subscriptions: subscriptionsReducer,
    expert: expertReducer,
    business_member: businessMemberReducer,
    business: businessReducer,
    leads: leadsReducer,
    meetings: meetingsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(firebaseAuthMiddleware, lyfshortServiceMiddleware, triplinkServiceMiddleware)
  ,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
